import { useState, useCallback } from 'react';
import { useGetOrganization } from '@sib/api';
import { useUserSetupStore } from '@sib/auth';
import { tracking } from '@sib/tracking';

export const useAskAi = () => {
  const [isAiModalOpen, setIsAiModalOpen] = useState(false);
  const [isAskAiModalOpen, setIsAskAiModalOpen] = useState(false);

  const organizationId = useUserSetupStore(state => state.organizationId);
  const { data: organization } = useGetOrganization(organizationId);

  const handleAskAi = useCallback(() => {
    tracking.track('Ask Spendbrain clicked');
    if (organization?.aiEnabled) {
      setIsAskAiModalOpen(true);
    } else {
      setIsAiModalOpen(true);
    }
  }, [organization?.aiEnabled]);

  const handleCloseAiModal = useCallback(() => {
    setIsAiModalOpen(false);
  }, []);

  const handleCloseAskAiModal = useCallback(() => {
    setIsAskAiModalOpen(false);
  }, []);

  return {
    isAiModalOpen,
    isAskAiModalOpen,
    organization,
    handleAskAi,
    handleCloseAiModal,
    handleCloseAskAiModal,
  };
};
